<script>
import { StatusCodes } from 'http-status-codes';

import List from '@/components/events/List';

export default {
    extends: List,

    async asyncData({
        query: { page: currentPage = 1, fromDate = '', toDate = '', q = '' },
        store: { dispatch },
        error
    }) {
        try {
            const params = {
                currentPage: parseInt(currentPage),
                perPage: 12,
                total: 0,
                search: q,
                fromDate,
                toDate
            };

            const { rows: events, count } = await dispatch(
                'events/index',
                params
            );

            params.total = count;

            return {
                events,
                params,
                hero: {
                    image: 'hero_image_events.jpg',
                    mobileImage: 'hero_image_events_mobile.jpg'
                },
                selectedFromDate: fromDate,
                selectedToDate: toDate
            };
        } catch (err) {
            if (err.response?.status !== StatusCodes.INTERNAL_SERVER_ERROR) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        pageTitle() {
            return this.$t('events.pageTitle');
        },

        headTitle() {
            const key = 'headTitles.events';

            return this.$te(key) ? this.$t(key) : this.pageTitle;
        },

        breadcrumbs() {
            return [
                {
                    text: this.$t('homepage.home'),
                    to: this.localePath('/')
                },
                {
                    text: this.pageTitle,
                    active: true
                }
            ];
        }
    }
};
</script>
